import PublisherInfoCom from './publisher-info/publisher-info.vue';
import ProjectInfoCom from './project-info/project-info.vue';
import projectBatchinfo from './project-batchinfo/project-info.vue';
import batchText from './project-batchinfo/batch-text/commitment-text.vue';
import TransfereeInfoCom from './transferee-info/transferee-info.vue';
import AttachmentInfoCom from './attachment-info/attachment-info.vue';
import CommitmentInfoCom from './commitment-info/commitment-info.vue';
import CommitmentText from './commitment-text/commitment-text.vue';
import SuccessCom from './success/success.vue';

export default [
  {
    path: 'publisher-info',
    name: 'publisherInfo',
    component: PublisherInfoCom
  },
  {
    path: 'project-info',
    name: 'projectInfo',
    component: ProjectInfoCom
  },
  {
    path: 'project-batchinfo',
    name: 'projectBatchinfo',
    component: projectBatchinfo
  },
  {
    path: 'transferee-info',
    name: 'transfereeInfo',
    component: TransfereeInfoCom
  },
  {
    path: 'attachment-info',
    name: 'attachmentInfo',
    component: AttachmentInfoCom
  },
  {
    path: 'commitment-info',
    name: 'commitmentInfo',
    component: CommitmentInfoCom
  },
  {
    path: 'commitment-text',
    name: 'CommitmentText',
    component: CommitmentText
  },
  {
    path: 'batch-text',
    name: 'batchText',
    component: batchText
  },
  {
    path: 'success',
    name: 'publishProjectSuccess',
    component: SuccessCom
  }
];
